import { CaseType, CaseTypeRepository } from '@telespot/domain';

export interface ListCaseTypesInput {
  searchTerm?: string;
  limit?: number;
  lastItemName?: string;
}

export interface ListCaseTypesOutput {
  id: string;
  name: string;
  description: string;
}

export interface IListCaseTypesQuery {
  /**
   * Lists case types ordered by name, paginated by `lastItemName` cursor.
   * Each item is projected to a flat shape with id, name and description.
   * Repository errors propagate so the caller's pagination effect can surface them.
   */
  execute(input: ListCaseTypesInput): Promise<ListCaseTypesOutput[]>;
}

export class ListCaseTypesQuery implements IListCaseTypesQuery {
  constructor(private readonly caseTypeRepository: CaseTypeRepository) {}

  public async execute(input: ListCaseTypesInput): Promise<ListCaseTypesOutput[]> {
    const caseTypes = await this.caseTypeRepository.getAll(input.searchTerm, input.limit, input.lastItemName);
    return caseTypes.map((caseType: CaseType) => ({
      id: caseType.id,
      name: caseType.name,
      description: caseType.description,
    }));
  }
}
